const getScheduleField = (schedule, camel, snake) => {
  if (!schedule) return undefined;
  if (schedule[camel] !== undefined && schedule[camel] !== null) return schedule[camel];
  return schedule[snake];
};

const getShiftField = (shift, camel, snake) => {
  if (!shift) return undefined;
  if (shift[camel] !== undefined && shift[camel] !== null) return shift[camel];
  return shift[snake];
};

const normalizeShortCode = (code) => {
  if (code === undefined || code === null) return null;
  const normalized = String(code).trim().toUpperCase();
  return normalized || null;
};

const inferBucketFromHour = (shift) => {
  const start = getShiftField(shift, 'start', 'start');
  if (!start) return null;

  const parsed = new Date(start);
  if (Number.isNaN(parsed.getTime())) return null;

  return parsed.getHours() < 12 ? 'AM' : 'PM';
};

export const createShiftBucketer = (schedule) => {
  const shiftTypes = Array.isArray(getScheduleField(schedule, 'shiftTypes', 'shift_types'))
    ? getScheduleField(schedule, 'shiftTypes', 'shift_types')
    : [];

  // Shift types by id only. The bucket used to be read from the type's short
  // code TEXT ("AM" / "PM"), then from "_AM_" inside the shift id -- which
  // embeds the location's name. It is now the start hour alone, the same rule
  // as the backend (verified: every department's AM types start before noon
  // and its PM types at or after it).
  const shiftTypesById = new Map();
  shiftTypes.forEach((shiftType) => {
    if (shiftType && typeof shiftType === 'object' && shiftType.id) shiftTypesById.set(String(shiftType.id), shiftType);
  });

  const getMeta = (shift) => {
    const shiftTypeId = getShiftField(shift, 'shiftTypeId', 'shift_type_id');
    const shiftType = shiftTypeId ? shiftTypesById.get(String(shiftTypeId)) || null : null;
    return {
      bucket: inferBucketFromHour(shift),
      // Display only: the type's own short code and label.
      shiftCode: normalizeShortCode(shiftType ? getScheduleField(shiftType, 'shortCode', 'short_code') : null),
      shiftLabel: getShiftField(shift, 'shiftTypeLabel', 'shift_type_label') || shiftType?.label || null,
    };
  };

  return {
    getBucket: (shift) => getMeta(shift).bucket,
    getMeta,
  };
};

export default createShiftBucketer;
